/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { Container, Divider, Typography } from "@material-ui/core";
import PageTitle from "../../../components/pageTitle/PageTitle";
import ThemeTablen from "../../../components/Table/ThemeTablen";
import CommonContext from "../../../hooks/commonContext";
import { getFormatedTime, getTimeZoneDate } from "../../../services/helpers";
import {
  getOneIssue,
  unArchiveIssue,
} from "../../../services/apiservices/issues.js";
import { DetailsColumns } from "../IssuesManageTableColumns";
import ViewAttachments from "./ViewAttachments";
import { getClientsList } from "../../../services/apiservices/client.js";
import { makeStyles } from "@material-ui/core/styles";
import { useMediaQuery } from "@mui/material";
import MailIcon from "@mui/icons-material/Mail";
import confirm from "../../../components/DialogComponent/confirm.js";
import { getAllEmployee } from "../../../services/apiservices/employee.js";
import AuthContext from "../../../hooks/authContext.js";
import { getSettings } from "../../../services/apiservices/settings.js";
import { Avatar, AvatarFallback } from "../../../components/ui/avtar.jsx";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card.jsx";
import { Archive } from "lucide-react";
import { Button } from "../../../components/ui/button.jsx";
import { useToast } from "../../../hooks/useToast.js";

const useStyles = makeStyles({
  customTooltip: {
    position: "absolute",
    margin: "auto",
    top: "15%",
    left: "176px",
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    padding: "10px",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
    zIndex: 100,
    width: "250px",

    "@media (max-width: 767px)": {
      width: "300px",
      height: "fit-content",
      overflowWrap: "break-word",
      top: "45px",
      left: 0,
      position: "absolute",
      margin: "auto",
      backgroundColor: "#fff",
      border: "0.1px solid #ccc",
      padding: "10px",
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      zIndex: 100,
    },
  },
  tooltipArrow: {
    position: "absolute",
    margin: "auto",
    top: "30%",
    left: "162px",
    zIndex: 1000,

    "@media (max-width: 767px)": {
      top: "28px",
      left: "10px",
      zIndex: 1000,
    },
  },
});

const TooltipArrow = ({ isMobile, isLandscape }) => {
  if (isMobile || isLandscape) {
    return (
      <svg
        width="15"
        height="20"
        viewBox="0 0 10 10"
        xmlns="http://www.w3.org/2000/svg"
      >
        <polygon points="5,0 10,10 0,10" fill="#fff" stroke="none" />
        <line x1="5" y1="0" x2="10" y2="10" stroke="#555" strokeWidth={0.1} />
        <line x1="5" y1="0" x2="0" y2="10" stroke="#555" strokeWidth={0.1} />
      </svg>
    );
  } else {
    return (
      <svg
        width="15"
        height="20"
        viewBox="0 0 10 10"
        xmlns="http://www.w3.org/2000/svg"
      >
        <polygon
          points="10,0 0,5 10,10"
          fill="#fff"
          stroke="#555"
          strokeWidth={0.2}
        />
      </svg>
    );
  }
};

const RecipientsTooltip = ({ recipients, styles }) => {
  if (!recipients || recipients.length === 0) return null;

  const recipientsString = recipients.join(", ");

  return <div className={styles.customTooltip}>{recipientsString}</div>;
};

const EscalateForm = ({ IssueDetail }) => {
  return (
    <div className="issueDetails mb-20 formtxtbtm">
      <h3 className="formtxt">Description</h3>
      <p>{IssueDetail?.description}</p>
      <ViewAttachments attachments={IssueDetail?.attachments} />
      <Divider fullWidth className="mt-10" />
    </div>
  );
};

function IssueArchiveDetails(props) {
  const { issueId } = useParams();
  const auth = useContext(AuthContext);
  const commonContext = useContext(CommonContext);
  const [IssueDetail, setIssueDetail] = useState([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const styles = useStyles();
  const isMobile = useMediaQuery("(max-width:767px)");
  const isLandscape = useMediaQuery(
    "(min-width: 771px) and (max-width: 940px)"
  );
  const [settingsData, setSettingsData] = React.useState();
  const companyId =
    auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;
  const { toast }= useToast();
  let history = useNavigate();
  const handleMouseOver = (responseItem) => {
    setShowTooltip(responseItem);
  };

  const handleMouseLeave = () => {
    setShowTooltip(null);
  };

  const fetchIssuesDetails = async () => {
    if (issueId && issueId !== "") {
      commonContext?.setLoader(true);
      let emails = [];
      const [clientsRes, employeesRes] = await Promise.all([
        new Promise((resolve) => getClientsList({}, resolve)),
        new Promise((resolve) => getAllEmployee(resolve)),
      ]);
      emails = clientsRes
        .map((client) => (client.contact && client.contact[0]?.email) || null)
        .filter((email) => email);
      await getOneIssue(
        issueId,
        async (res) => {
          if (res && res.status === true) {
            const data = employeesRes?.data.find(
              (item) => item.userId === res?.data?.employee.id
            );
            let details = {
              ...res.data,
              issuueId: `IS - ${String(res.data?.issueNumber)
                .match(/\d+/)?.[0]
                .padStart(4, "0")}`,
              employeeName: res.data?.employee?.name,
              clientName: res.data?.client?.name,
              dateOfRequest: res.data?.dateOfRequest,
              clientData: emails,
              timeZone: data?.timeZone,
            };
            let responses =
              details?.responses &&
              [...Object.keys(details?.responses)].map((key) => {
                return { ...details?.responses[key], id: key };
              });
            responses = responses
              ? responses.sort((a, b) => (a.respondOn > b.respondOn ? 1 : -1))
              : [];
            setIssueDetail({ ...details, responses: responses });
            commonContext?.setLoader(false);
          } else {
            commonContext?.setLoader(false);
          }
        },
        (resError) => {
          console.log("reserror", resError);
          commonContext?.setLoader(false);
        }
      );
      commonContext?.setLoader(false);
    }
  };
  useEffect(() => {
    fetchIssuesDetails();
    getSettings("issue_settings", (res) => {
      if (res?.data.length > 0) {
        const filteredData = res?.data?.filter(
          (item) => item?.companyId === companyId && !item.deleted
        );
        const data = filteredData?.[0];
        setSettingsData(data);
      } else {
        setSettingsData();
      }
    });
  }, [issueId]);

  const UnArchiveIssues = async () => {
    if (issueId && issueId !== "") {
      commonContext?.setLoader(true);
      await unArchiveIssue(
        issueId,
        async (res) => {
          history("/operations/issues/archive");
          toast?.({title: "Success", description: "Issue UnArchive Successfully"});
        },
        (resError) => {
          commonContext?.setLoader(false);
        }
      );
      commonContext?.setLoader(false);
    }
  };

  const OnClickUnArchive = async () => {
    await confirm("Are you sure you want to UnArchive this issue ?").then(
      () => {
        UnArchiveIssues();
      },
      () => console.log("cancel!")
    );
  };

  const getEmailDisplay = (item) => {
    if (item?.escalatedTo && item?.escalated === "Respond from Email") {
      return (
        <div
          className={`d-flex ${
            isMobile || isLandscape ? "flex-start mb-0" : "flex-center mb-8"
          }`}
          style={{ overflowWrap: "anywhere", fontStyle: "normal" }}
        >
          <div>
            <MailIcon
              style={{ fontSize: 16, verticalAlign: "middle", color: "gray" }}
            />
          </div>
          <span
            className={isMobile ? "ml-5 mt-4" : "ml-5"}
            style={{ color: "blue", width: "90%", lineHeight: "20px" }}
          >
            {item?.respondBy?.email}
          </span>
        </div>
      );
    }
    return (
      <p
        className={isMobile ? "color-newBlack dark:text-white" : "color-newBlack dark:text-white mb-8"}
        style={{ fontSize: "16px", fontWeight: "500", fontStyle: "normal" }}
      >
        {item?.respondBy?.name}
      </p>
    );
  };

  return (
    <Container>
      <PageTitle
        pageTitle="Issue Archive Detail"
        showBreadcrumb={[
          { label: "Home", to: "/" },
          { label: "Issue Archive", to: "/issues/Archive" },
        ]}
        BreadCrumbCurrentPageTitle={"Archived Issue"}
      />

      <div className={isMobile ? "pv-20 ph-15" : "p-24"}>
        <div style={{ maxWidth: "1280px", margin: "0px auto" }}>
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center justify-between mb-6">
            <div>
              <h1 className="text-2xl font-bold flex items-center gap-2">
                <span className="dark:text-white">{IssueDetail?.issuueId}</span>
                {IssueDetail?.escalated_to_admin === true && (
                  <span className="bg-red-100 text-red-800 text-xs px-2 py-1 rounded">
                    Escalated
                  </span>
                )}
              </h1>
              <p className="text-muted-foreground">
                {IssueDetail?.description}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <Button
                variant="outline"
                className={
                  "text-blue-600 border-blue-200 hover:bg-blue-50 hover:text-blue-700"
                }
                onClick={() => OnClickUnArchive()}
                // disabled={
                //   settingsData
                //     ? settingsData?.[0] &&
                //       !settingsData?.[0]?.archiveRequestRole?.includes(
                //         auth?.userProfile?.role
                //       )
                //     : false
                // }
              >
                <Archive className="mr-2 h-4 w-4" />
                UnArchive Issue
              </Button>
            </div>
          </div>

          <ThemeTablen
            rows={[IssueDetail]}
            headCells={DetailsColumns}
            hidePagination={true}
          />

          <Card className="bg-white dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
            <CardHeader className="p-24">
              <CardTitle className="text-xl">Comments & Activity</CardTitle>
            </CardHeader>
            <CardContent className="pt-0 ph-24 pb-24">
              <div className="mh-15 alertselect">
                <div className="issueDetails mb-20">
                  {IssueDetail?.responses &&
                    IssueDetail?.responses
                      ?.sort((a, b) => b?.respondOn - a?.respondOn)
                      ?.map((responseItem, index) => {
                        return (
                          <div
                            key={index}
                            className=" d-flex mb-15 bg-slate-50 rounded-lg p-16 position-relative gap-4 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]"
                          >
                            <div className="flex items-start">
                              <Avatar className="h-10 w-10 border">
                                <AvatarFallback className="bg-purple-100 text-purple-800">
                                  {responseItem?.respondBy?.name
                                    .split(" ")
                                    .map((name) => name[0])
                                    .join("")
                                    .toUpperCase()}
                                </AvatarFallback>
                              </Avatar>
                            </div>
                            <div className="w-100">
                              <Typography
                                variant="subtitle1"
                                style={{ fontStyle: "normal" }}
                              >
                                <div className={isMobile ? "mb-8" : ""}>
                                  {responseItem?.escalatedTo ? (
                                    <div
                                      className={
                                        isMobile
                                          ? "d-flex flex-direction-column"
                                          : "d-flex flex-space-between"
                                      }
                                    >
                                      <span
                                        className={isMobile ? "W-100" : "w-65"}
                                      >
                                        {getEmailDisplay(responseItem)}
                                      </span>{" "}
                                      <span
                                        className="w-20"
                                        style={{
                                          color: "#6B7280",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {getTimeZoneDate(
                                          responseItem?.respondOn,
                                          IssueDetail?.timeZone
                                        )}{" "}
                                        {getFormatedTime(
                                          responseItem?.respondOn,
                                          IssueDetail?.timeZone
                                        )}
                                      </span>
                                    </div>
                                  ) : (
                                    <div
                                      className={
                                        isMobile
                                          ? "d-flex flex-direction-column"
                                          : "d-flex flex-space-between"
                                      }
                                    >
                                      <span
                                        className={isMobile ? "W-100" : "w-65"}
                                      >
                                        {getEmailDisplay(responseItem)}
                                      </span>{" "}
                                      <span
                                        className="w-20"
                                        style={{
                                          color: "#6B7280",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {getTimeZoneDate(
                                          responseItem?.respondOn,
                                          IssueDetail?.timeZone
                                        )}{" "}
                                        {getFormatedTime(
                                          responseItem?.respondOn,
                                          IssueDetail?.timeZone
                                        )}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </Typography>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html:
                                    responseItem?.escalatedTo &&
                                    responseItem?.escalated ===
                                      "Respond from Email"
                                      ? responseItem?.details
                                          .split("On")[0]
                                          .trim()
                                          .replace(/<[^>]*>/g, "")
                                          .replace(/(\d+\.\s?)/g, "<br>$1")
                                      : responseItem?.description
                                          .replace(/<[^>]*>/g, "")
                                          .replace(/(\d+\.\s?)/g, "<br>$1"),
                                }}
                                className="mb-12 dark:text-[#6B7280] text-[#1F2937]"
                                style={{
                                  fontSize: "14px",
                                  // color: "#1F2937",
                                  fontWeight: "500",
                                }}
                              ></div>
                              <div className="d-flex flex-space-between flex-end">
                                <div className="mt-8">
                                  <button
                                    className="text-xs text-blue-600 hover:text-blue-800"
                                    onClick={() =>
                                      setShowTooltip(
                                        showTooltip === false
                                          ? responseItem
                                          : false
                                      )
                                    }
                                  >
                                    {showTooltip === responseItem
                                      ? "Hide recipients"
                                      : "Show recipients"}
                                  </button>

                                  {showTooltip === responseItem && (
                                    <div className="mt-8 text-xs text-gray-500 bg-gray-100 p-8 rounded">
                                      <strong>Recipients:</strong>{" "}
                                      {responseItem?.recipients?.join(", ")}
                                    </div>
                                  )}
                                </div>
                                <div
                                  style={{
                                    width: isMobile || isLandscape ? "40%" : "",
                                  }}
                                >
                                  <ViewAttachments
                                    attachments={responseItem?.attachments}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </Container>
  );
}

export default IssueArchiveDetails;
